
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { sumbitOrder } from '@/api/youzheng.js'
import { getAddressDefault, getintegral } from '@/api/user.js'
import { getSelfAddress } from '@/api/sys.js'
import Storage from '@/storage'
import errorImg from '@/assets/mall/img-error.png'
import config from '@/config/index'
import addressedit from '@/views/address-select'
import { getProductDetail, stampPay, stampGet, change, homePage } from '@/api/jianianhua'
import axios from 'axios'
export default {
directives: {
TransferDom
},
data () {
return {
id: this.$route.params.productid,
goodsObj: {},
baseUrl: config.baseUrl,
errorImg: errorImg,
score: 0,
num: 1,
addressObj: {},
openid: Storage.get('openId'),
owner_type: config.owner_type,
integral: '',
deliveryList: [{
name: '自提',
value: '1'
}, {
name: '快递',
value: '2'
}],
delivery: ['2'],
selfAddress: '',
maxnum: 0,
isColor: ['#db2111', '#ec653c'],
openAddress: false,
message: '',
stampnum: ''

}
},
components: {
Cell,
Group,
Flexbox,
FlexboxItem,
XNumber,
XTextarea,
XButton,
PopupRadio,
PopupPicker,
Popup,
addressedit
},
created () {
this.getAddress()
this.getDetail()
this.getintegralTotal()
this.getstamp()
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
activated () {
console.log(22)
if (this.$store.state.user.address.ID !== '') {
this.openAddress = true

}
},
watch: {
num (val) {
if (val < 1 && val !== '') {
this.$vux.toast.text('受不了了，宝贝不能再减少了哦', 'middle')
} else if (this.goodsObj.limitnum == 0 && val >= this.goodsObj.ou) {
this.$vux.toast.text('该商品最多只能购买' + this.goodsObj.ou + '件', 'middle')
} else if (this.goodsObj.limitnum >= this.goodsObj.ou && this.goodsObj.limitnum != 0) {
this.$vux.toast.text('该商品最多只能购买' + this.goodsObj.ou + '件', 'middle')
} else if (this.goodsObj.limitnum < this.goodsObj.ou && this.goodsObj.limitnum != 0) {
this.$vux.toast.text('该商品最多只能购买' + this.goodsObj.limitnum + '件', 'middle')
}
this.score = this.goodsObj.ypnum * val
},
delivery: {
handler (val) {
if (val == 1) {
this.getlift()
}
},
deep: true
}
},
methods: {
getstamp () {
homePage({
accountId: this.accountid
}).then(data => {
this.stampnum = data.obj.num
})
},
getintegralTotal () {
getintegral({
accountid: this.accountid,
userid: this.userid,
owner_type: this.owner_type
}).then(res => {
this.integral = res.returnValue.allnow
})
},
getAddress () {
getAddressDefault({
accountid: this.accountid,
userid: this.userid
}).then(res => {
if (res.returnValue != '') {
this.addressObj = res.returnValue
}
})
},
getDetail () {
getProductDetail({
id: this.id
}).then(res => {
this.goodsObj = res.obj
this.score = this.goodsObj.ypnum * this.num
if (this.goodsObj.limitnum !== 0) {
if (this.goodsObj.ou <= this.goodsObj.limitnum) {
this.maxnum = this.goodsObj.ou
} else {
this.maxnum = this.goodsObj.limitnum
}
} else {
this.maxnum = this.goodsObj.ou
}
})
},
onImgError ($event) {
$event.target.src = this.errorImg
},
getnow () {
const date = new Date()
let year = date.getFullYear()
let month = date.getMonth() + 1
month = month > 9 ? month : '0' + month
let day = date.getDate()
day = day > 9 ? day : '0' + day
return `${year}-${month}-${day}`
},
sumbit () {
if (JSON.stringify(this.addressObj) !== '{}') {
if (this.num > 0) {
if (this.stampnum >= this.score) {
change({
accountId: this.accountid,
id: this.id,
ruleCode: 'YPDH002',
startdate: this.getnow() + ' 10:30:00',
enddate: this.getnow() + ' 16:30:00',
addressid: this.addressObj.ID
}).then(res => {
if (res.obj) {
this.$vux.toast.text('兑换成功！')
window.history.go(-1)
} else {
this.$vux.toast.text(res.msg)
window.history.go(-1)
}
})
} else {
this.$vux.toast.text('邮票数不足')
}




























} else {
this.$vux.toast.text('请选择兑换数量', 'middle')
}
} else {
this.$vux.toast.text('请选择收货地址', 'middle')
}
},

getlift () {
getSelfAddress().then(res => {
if (res.obj && res.obj.length > 0) {
this.selfAddress = res.obj[1].value
}
})
},
openPopup () {
this.openAddress = true

},
changeAddress (isdisplay) {
if (isdisplay === 'false') {
this.openAddress = false
this.addressObj = this.$store.state.user.address
}
}
},
beforeRouteEnter (to, from, next) {
next(vm => {
if (from.name === 'addressAdd') {
vm.openAddress = true
}
})
}
}
